/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CasesRouteImport } from './routes/cases'
import { Route as JiraRouteImport } from './routes/jira'
import { Route as RunsRouteImport } from './routes/runs'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SuitesRouteImport } from './routes/suites'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminUsersRouteImport } from './routes/admin.users'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesRoute = CasesRouteImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => rootRouteImport,
} as any)
const JiraRoute = JiraRouteImport.update({
  id: '/jira',
  path: '/jira',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsRoute = RunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SuitesRoute = SuitesRouteImport.update({
  id: '/suites',
  path: '/suites',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cases': typeof CasesRoute
  '/jira': typeof JiraRoute
  '/runs': typeof RunsRoute
  '/settings': typeof SettingsRoute
  '/suites': typeof SuitesRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/users': typeof AdminUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cases': typeof CasesRoute
  '/jira': typeof JiraRoute
  '/runs': typeof RunsRoute
  '/settings': typeof SettingsRoute
  '/suites': typeof SuitesRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/users': typeof AdminUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cases': typeof CasesRoute
  '/jira': typeof JiraRoute
  '/runs': typeof RunsRoute
  '/settings': typeof SettingsRoute
  '/suites': typeof SuitesRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/users': typeof AdminUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cases'
    | '/jira'
    | '/runs'
    | '/settings'
    | '/suites'
    | '/admin/audit'
    | '/admin/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cases'
    | '/jira'
    | '/runs'
    | '/settings'
    | '/suites'
    | '/admin/audit'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/cases'
    | '/jira'
    | '/runs'
    | '/settings'
    | '/suites'
    | '/admin/audit'
    | '/admin/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CasesRoute: typeof CasesRoute
  JiraRoute: typeof JiraRoute
  RunsRoute: typeof RunsRoute
  SettingsRoute: typeof SettingsRoute
  SuitesRoute: typeof SuitesRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases': {
      id: '/cases'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof CasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jira': {
      id: '/jira'
      path: '/jira'
      fullPath: '/jira'
      preLoaderRoute: typeof JiraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs': {
      id: '/runs'
      path: '/runs'
      fullPath: '/runs'
      preLoaderRoute: typeof RunsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suites': {
      id: '/suites'
      path: '/suites'
      fullPath: '/suites'
      preLoaderRoute: typeof SuitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CasesRoute: CasesRoute,
  JiraRoute: JiraRoute,
  RunsRoute: RunsRoute,
  SettingsRoute: SettingsRoute,
  SuitesRoute: SuitesRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminUsersRoute: AdminUsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
